import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, of, tap, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor(
    private _snackBar: MatSnackBar,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        next: (event) => {
          return event;
        },
        error: (error) => {
          console.debug(error)
          console.debug(error)
          if (error instanceof HttpErrorResponse) {
            if (error.status === 404) {
              // Handle 404 errors separately (you can choose to do nothing or debug it)
              console.warn('HTTP 404 Error:', error);
              return of(null); // Return an observable to continue the stream without propagating the error
            }
            if (error.status === 401) {
              if(error.error._error.message==="Login failed"){
                this._snackBar.open("Incorrect Username or Password!!", 'Close', {
                  duration: 5000,
                });
                console.warn('HTTP 401 Error:', error);
                return of(null); 
              }
              console.warn('HTTP 401 Error:', error);
              window.location.href="/logout";
              this._snackBar.open("You Changed Password Using Mobile App,Please Relogin First!!!", 'Close', {
                duration: 7000,
              });
              return of(null); 
            }
            if (error.status === 422) {
              if(error.error._issues.email_address!=undefined)
                this._snackBar.open(error.error._issues?.email_address, 'Close', {
                  duration: 5000,
                });
              if(error.error._issues.username!=undefined)
                this._snackBar.open(error.error._issues?.username, 'Close', {
                  duration: 5000,
                });  
              if(error.error._issues.phone_number!=undefined)
                this._snackBar.open(error.error._issues?.phone_number, 'Close', {
                  duration: 5000,
                });      
                console.error(error.error._issues)
              return of(null); 
            }
            if (
              error &&
              error.error &&
              error.error._status &&
              String(error.error._status).toLowerCase() === 'error' &&
              error.error._error &&
              error.error._error.message &&
              error.error._error.message.length > 0
            ) {
              if (Array.isArray(error.error._error.message) === true) {
                this._snackBar.open('ERROR: ' + error.error._error.message[1], error.error._error.message[0]);
              } else {
                this._snackBar.open('ERROR: ' + error.error._error.message, '');
              }
            } else if (
              error &&
              error.error &&
              error.error._status &&
              String(error.error._status).toLowerCase() === 'err' &&
              error.error._issues
            ) {
              this._snackBar.open('ERROR: ' + JSON.stringify(error.error._issues), '');
            } else if (
              error &&
              error.ok === false
            ) {
              this._snackBar.open('ERROR: ' + JSON.stringify(error.message), '');
            } else {
              this._snackBar.open('ERROR: ' + JSON.stringify(error), '');
            }
          }
          return throwError(error);
        }
      })
    );
  }
}
